"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useAppShellContext } from "../AppShell.context.mjs";
import AppShell_module_default from "../AppShell.module.mjs";
import { RemoveScroll } from "react-remove-scroll";
import cx from "clsx";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/AppShell/AppShellFooter/AppShellFooter.tsx
const AppShellFooter = factory((_props) => {
	const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = useProps("AppShellFooter", null, _props);
	const ctx = useAppShellContext();
	if (ctx.disabled) return null;
	return /* @__PURE__ */ jsx(Box, {
		component: "footer",
		mod: [{ "with-border": withBorder ?? ctx.withBorder }, mod],
		...ctx.getStyles("footer", {
			className: cx({ [RemoveScroll.classNames.zeroRight]: ctx.offsetScrollbars }, className),
			classNames,
			styles,
			style
		}),
		...others,
		__vars: { "--app-shell-footer-z-index": (zIndex ?? ctx.zIndex)?.toString() }
	});
});
AppShellFooter.classes = AppShell_module_default;
AppShellFooter.displayName = "@mantine/core/AppShellFooter";
//#endregion
export { AppShellFooter };

//# sourceMappingURL=AppShellFooter.mjs.map